import { useEffect, useLayoutEffect } from 'react';
import {
  BrowserRouter,
  Outlet,
  Routes,
  Route,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import Box from '@mui/material/Box';
import { TopAppBar } from './components';
import { HomePage, AuthCallbackPage, EmbedPage, SunriseTicketPage, AdminKeywordsPage } from './pages';

/**
 * Pages start at the top after navigation. The browser's own restoration is
 * disabled because it runs before results are rendered; the result view
 * restores its scroll position itself once they are.
 */
function ScrollManager() {
  const { key } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
  }, []);

  useLayoutEffect(() => {
    // REPLACE only updates the URL of the current view (e.g. filters, page).
    if (navigationType !== 'REPLACE') window.scrollTo(0, 0);
  }, [key, navigationType]);

  return null;
}

/** App chrome. `/embed` renders outside this so the overlay has no top bar. */
function AppLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <ScrollManager />
      {/* Top App Bar */}
      <TopAppBar />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: { xs: 0, sm: 10 }, // xs=0: AppBar is sticky on mobile; sm=80px: fixed AppBar offset on desktop
          bgcolor: 'background.default',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/embed" element={<EmbedPage />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/sunrise/tickets/:ticketId" element={<SunriseTicketPage />} />
          <Route path="/admin/keywords" element={<AdminKeywordsPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
